import locales from '@spa/shared/constants/locales';
import { PATH_TRANSLATIONS } from '@spa/shared/constants/url';

export const findKeyByTranslation = translation =>
  Object.values(PATH_TRANSLATIONS)
    .flatMap(translations => Object.entries(translations))
    .find(([, value]) => value === translation)?.[0];

export const translatePathFilters = (path, language = 'en') => {
  const [mainPath, queryParams] = path.split('?');
  const [staticPath, filters] = mainPath.split('/f/');
  if (!filters) {
    return path === '/' ? '' : path;
  }

  const translatedCategories = filters
    .split(';')
    .map(category =>
      category
        .split(',')
        .map(filter => PATH_TRANSLATIONS[language]?.[findKeyByTranslation(filter)] || null)
        .filter(Boolean)
        .join(',')
    )
    .join(';');
  const translatedPath = `${staticPath}/f/${translatedCategories}`;

  return queryParams ? `${translatedPath}?${queryParams}` : translatedPath;
};

export const removeLanguageFromPath = path => {
  const localeRegex = new RegExp(`^/(${Object.keys(locales).join('|')})/|/(${Object.keys(locales).join('|')})/`, 'i');

  return path.replace(localeRegex, '/');
};
